module.exports = __webpack_public_path__ + "static/media/roleplace-nav-logo.a21cb381.svg";